<div class="sidebar" *ngIf="(isMobile$ | async) === false">
    <ng-content select="[top]"></ng-content>

    <router-outlet name="sidebar"></router-outlet>

    <div class="sidebar__bottom">
        <ng-content select="[bottom]"></ng-content>
    </div>
</div>
